import { useEffect, useState } from "react";
import TeacherStudentSettingsHeader from "../../components/TeacherStudentSettingsHeader/TeacherStudentSettingsHeader";
import './StudentProfile.scss';
import { useAppSelector } from "../../redux/app/hooks";
import StudentProfileForm from "../../components/StudentProfileForm/StudentProfileForm";
import { logout, setAdminProfile, setAdminProfileImage, setRefetchCurrentUser } from "../../redux/slices/authSlice";
import Loader from "../../components/Loader/Loader";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { GET_CURRENT_USER } from "../AdminDashboard/api/AdminDashboardQuery";
import ToasterWithMessage from "../../components/toaster";
import images from "../../assets/images";
import { FETCH_POLICY_NO_CACHE, SCHOOL_ADMIN, STUDENT_ROLE } from "../../utils/constants";

const StudentProfile = () => {

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const profile = useAppSelector((state) => state.auth.adminProfile?.getCurrentUser?.nodes?.[0]);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);  
    const dispatch = useDispatch();  
    const {error} = ToasterWithMessage()
    const { schoolProfileImage } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const role = useAppSelector((state) => state.auth.role);
    const studentClasscode: string |null = localStorage.getItem('studentClassCode')

    const handleClick = () => {
        setIsEdit(true);
        if (isEdit) {
            setIsSubmit(!isSubmit);
        }
    }

    const [getCurrentUser, { loading }] = useLazyQuery(GET_CURRENT_USER,{
                fetchPolicy: FETCH_POLICY_NO_CACHE,
                onCompleted: (data) => {
                  if(data && data?.getCurrentUser){
                        dispatch(setAdminProfile({profile: data}));
                        dispatch(setAdminProfileImage({ adminProfileImage: role === SCHOOL_ADMIN ? data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl : schoolProfileImage : data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
                  }else {
                    error("User Not Found!");
                  }
                },
                onError: (err) => {
                  error(err?.message);
                  dispatch(logout());
                }
              });
        
        useEffect(() => {
           if(role === STUDENT_ROLE){
                   getCurrentUser({
                     variables : {
                       classCode : studentClasscode
                     }
                   })
                 }
               else {
                 getCurrentUser({
                   variables : {
                       classCode : ""
                     }
                 });
               } 
            // dispatch(setRefetchCurrentUser({ refetchCurrentUser: true }));
        }, [])

    return (
        <div className="studentProfile">
            <div className="studentProfileHeader">
                <TeacherStudentSettingsHeader
                    title="My Profile"
                    subTitle="Add Profile image to your person details"
                />
                <div className="ctaActions">
                    <button className="editBtnStyle" onClick={handleClick}>{isEdit ? "Save" : "Edit"}</button>
                </div>
            </div>
            <div className="FormContainer">
                {(profile === undefined) ? <Loader /> : (
                    <StudentProfileForm 
                        id={profile?.studentsByUId?.nodes?.[0]?.sId}
                        fullName={profile?.uFullName}
                        username={profile?.uUserName}
                        password={profile?.uUserPassword}
                        phonenumber={profile?.uPhoneNumber}
                        email={profile?.uEmailId} 
                        avatarUrl={profile?.studentsByUId?.nodes?.[0]?.sAvatarUrl} 
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        isSubmit={isSubmit}
                    />
                )}
            </div>
        </div>
    )
}

export default StudentProfile;